import React from 'react';
import { Flex, TextV2 } from '@withjoy/joykit';
import { MapMarker } from '@withjoy/joykit/icons';
import { useTranslation } from '@shared/core';
import { MapPinProps } from './MapPin';
import { pxToRem } from '@withjoy/joykit/theme';
import { OverlayView } from '@react-google-maps/api';
import { StyledMapPinLabel, StyledMapPinLabelContainer, StyledMapPinLabelTip, StyledMapPinLabelTipShadow, styles } from './MapPin.styles';

/**
 * VenueMapPin - Map pin for the venue location.
 *
 * This component renders a map pin for the venue location.
 * It uses the MapPin component and adds a label with the venue name.
 */
export const VenueMapPin: React.FC<Pick<MapPinProps, 'position'>> = ({ position }) => {
  const { tq } = useTranslation('travelMap');

  return (
    <OverlayView
      mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
      position={position}
    >
      <StyledMapPinLabelContainer
        role="group"
        __css={styles.joyMapPinLabelContainer({ isActive: false, isClickable: false, showOnTop: true, isCardVisible: false })}
      >
        <StyledMapPinLabelTipShadow
          __css={styles.joyMapPinLabelTipShadow}
          filter="none"
        />
        <StyledMapPinLabel
          __css={styles.joyMapPinLabel({ isActive: false, isClickable: false, isCardVisible: false })}
          boxShadow="0 1px 3px -1px rgba(0, 0, 0, 0.12)"
        >
          <Flex
            justifyContent="center"
            alignItems="center"
            columnGap={3}
          >
            <MapMarker
              size={16}
              color="mono14"
            />
            <TextV2
              typographyVariant="label3"
              fontSize={pxToRem(13)}
              color="mono15"
              fontWeight={600}
              fontFamily="Inter UI"
            >{tq`Your Venue`}</TextV2>
          </Flex>
        </StyledMapPinLabel>
        <StyledMapPinLabelTip __css={styles.joyMapPinLabelTip({ isActive: false, isClickable: false, isCardVisible: false })} />
      </StyledMapPinLabelContainer>
    </OverlayView>
  );
};
